<template>
    <div class="bg-wrap-color">
        <div class="p20 bg-color mb10 mi_create_header_fixed" :style="{width: fixWidth}">
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleCancel" v-matomo="{behaviorCategory: '小米(自动优化批量搭建)',  name: isCopy?'列表(复制-生成预览-取消)':'批量创建(生成预览-取消)' }"><i class="el-icon-back"></i>取消</span>
            |
            <!--任务ID： {{id}}-->
            <span class="ml16 tip text-bold mr20">批量创建</span>

            <el-button type="default" size="mini" @click="handleClick" ghost v-matomo="{behaviorCategory: '小米(自动优化批量搭建)',  name: isCopy?'列表(复制-生成预览-上一步)':'批量创建(生成预览-上一步)' }">上一步</el-button>
            <el-button :loading="submitLoading" type="primary" size="mini" @click="submitTask" v-matomo="{behaviorCategory: '小米(自动优化批量搭建)',  name: isCopy?'列表(复制-生成预览-提交创建)':'批量创建(生成预览-提交创建)' }">提交创建</el-button>

        </div>
        <div style="height: 80px;"></div>
        <div class="pl20 pr20 pt10 pb10 bg-color mb10" id="mi_create_body">
            <p class="text-bold">目标账户与产品：</p>
            <p v-if="dataLoading||totalLoading">
                <span class="text-bold"> 账户：</span> - ；
                <span class="text-bold"> 产品：</span>  -
            </p>
            <p v-else>
                <span class="text-bold"> 账户：</span> {{account_info.account_name}}（ID：{{account_info.account_id}}）；
                <span class="text-bold"> 产品：</span> {{app_info.map(item=>item.app_name+'('+item.app_id+')').join('、')}}
            </p>
        </div>

        <div class="pl20 pr20 pt10 pb10 bg-color" id="mi_create_body">
            <el-button type="primary" size="mini" plain @click="handleEditName('修改广告描述', 'description')" :loading="dataLoading">修改广告描述</el-button>
            <el-button type="primary" size="mini" plain @click="handleEditName('修改推广产品描述', 'product_description')"  :loading="dataLoading">修改推广产品描述</el-button>
            <el-button type="primary" size="mini" plain @click="handleEditName('修改广告品牌描述', 'brand')"  :loading="dataLoading">修改广告品牌描述</el-button>
            <el-tooltip class="item" effect="dark" content="去除广告描述、推广产品描述、广告品牌描述中的特殊字符，只保留文字、数字、字母。" placement="top">
                <el-button type="primary" size="mini" plain @click="handleDoubleConfirmation" :loading="dataLoading">去除特殊字符<i class="el-icon-question"></i></el-button>
            </el-tooltip>
        </div>
        <el-table :data="tableData"
                  ref="multipleTable"
                  style="width: 100%;margin-top: 0;"
                  stripe
                  :header-cell-style="{background:'#e8eaec',color:'#333'}"
                  :row-class-name="tableRowClassName"
                  size="mini"
                  row-key="id"
                  class="create_vivo_list"
                  v-loading="dataLoading||totalLoading"
                  tooltip-effect="dark"
                  @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55"
                :selectable="checkSelect"
            >
            </el-table-column>
            <el-table-column label="序号" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0" class="text-bold">总计</span>
                    <span v-else>{{((queryData.pn-1)*queryData.rn)+scope.$index}}</span>
                </template>
            </el-table-column>
            <el-table-column label="计划" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{total_info.plan_total}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.plan_name" placement="top">
                                <span>{{ scope.row.plan_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.plan_id">ID:{{scope.row.plan_id}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="投放范围" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else-if="scope.row.campaign_type=='1'">商店</span>
                    <span v-else-if="scope.row.campaign_type=='2'">非商店</span>
                    <span v-else-if="scope.row.campaign_type=='3'">米盟</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="广告组" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{total_info.adgroup_total}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.adgroup_name" placement="top">
                                <span>{{ scope.row.adgroup_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.adgroup_id">ID:{{scope.row.adgroup_id}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="版位" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.display_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="应用" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.app_name||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="广告创意" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{total_info.ad_total}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ad_name" placement="top">
                                <span>{{ scope.row.ad_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.ad_id">ID:{{scope.row.ad_id}}</p>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="广告描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <div class="mi_previewBoxflex">
                            <div>
                                <p class="ellipsis-row-2">
                                    <el-tooltip class="item" effect="dark" :disabled="!scope.row.description" :content="scope.row.description" placement="top">
                                        <span>{{ scope.row.description || '-' }}</span>
                                    </el-tooltip>
                                </p>
                            </div>
                            <div class="edit" v-if="scope.row.description_conf_length !=0" @click="handleEditName('修改广告描述', 'description', scope.row)"><i class="el-icon-edit-outline"></i></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="推广产品描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <div class="mi_previewBoxflex">
                            <div>
                                <p class="ellipsis-row-2">
                                    <el-tooltip class="item" effect="dark" :disabled="!scope.row.product_description" :content="scope.row.product_description" placement="top">
                                        <span>{{ scope.row.product_description || '-' }}</span>
                                    </el-tooltip>
                                </p>
                            </div>
                            <div class="edit" v-if="scope.row.product_description_conf_length !=0" @click="handleEditName('修改推广产品名称', 'product_description', scope.row)"><i class="el-icon-edit-outline"></i></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="广告品牌描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <div class="mi_previewBoxflex">
                            <div>
                                <p class="ellipsis-row-2">
                                    <el-tooltip class="item" effect="dark" :disabled="!scope.row.brand" :content="scope.row.brand" placement="top">
                                        <span>{{ scope.row.brand || '-' }}</span>
                                    </el-tooltip>
                                </p>
                            </div>
                            <div class="edit" v-if="scope.row.brand_conf_length !=0" @click="handleEditName('修改广告品牌描述', 'brand', scope.row)"><i class="el-icon-edit-outline"></i></div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="转化类型" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.conversion_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="转化名称" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.conversion_name||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="素材规格" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.emi_material_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column label="创意类型" min-width="200"  show-overflow-tooltip>-->
                <!--<template slot-scope="scope">-->
                    <!--<span v-if="scope.$index==0"></span>-->
                    <!--<span v-else>{{scope.row.placement_type_text||'-'}}</span>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column label="广告标题" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.title||''}}</span>
                </template>
            </el-table-column>
            <el-table-column label="创意" min-width="300">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <template v-else>
                        <IdeaColumnTemp :list="scope.row.creative_list||[]" />
                        <span v-if="(scope.row.creative_list||[]).length<=0">-</span>
                    </template>
                </template>
            </el-table-column>
        </el-table>

        <div class="bg-color tar p20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[30,50,100]"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import IdeaColumnTemp from '../components/ideaColumnTemp';
    import { adsEditNameModal, doubleConfirmationModal, submitErrorModal } from '../modal'
    import API from '@/api/marketManage/miBatchAuto.js';
    export default {
        name:'PreviewResult',
        components:{
            IdeaColumnTemp,
        },
        props: ['getFormDate','dataId'],
        data(){
            let _this = this;
            return {
                id:_this.dataId,
                dataLoading:false,
                totalLoading:false,
                account_info:{
                    account_id:'',
                    account_name:'',
                },
                app_info:[],
                total_info: {               //数据汇总
                    plan_num:'',
                    plan_total:'',
                    adgroup_num:'',
                    adgroup_total:'',
                    ad_num:'',
                    ad_total:'',
                },
                queryData: {
                    pn: 1,
                    rn: 30,
                },
                tableData: [],
                multipleSelection:[],
                totalCnt: 0,
                submitLoading:false,
                fixWidth: '1000px',
            }
        },
        computed:{
            ...mapGetters(['sidebar']),
        },
        watch:{
            sidebar: {
            handler(n, o){
                setTimeout(()=>{
                this.getFixWidth()
                }, 300)
            },
            deep: true
            }
        },
        mounted(){
            this.getFixWidth()
            window.addEventListener('resize', this.getFixWidth);
            this.getTotalData();
        },
        methods:{
            getFixWidth() {
                let mi_create_body = document.getElementById('mi_create_body')
                if(mi_create_body) {
                    let mi_width = mi_create_body.clientWidth
                    this.fixWidth = `${mi_width}px`
                }
            },
            handleCancel(){
                this.$confirm(`取消后已经添加的内容不会保存，确认要取消吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                }).then(() => {
                    this.$emit("changePage", "listPage",'',{});
                }).catch(() => {});
            },
            handleClick(){
                this.$emit("changePage", "configPage",'',this.getFormDate())
            },
            // 每页条数
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            // 当前页数
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            getTotalData() {
                let reqData = {
                    task_id:this.id,
                };
                this.totalLoading = true;
                API.getBatchPreviewInfo(reqData).then(res=>{
                    this.totalLoading = false;
                    let resData = res.data||{};
                    this.account_info = resData.account_info||{};
                    this.app_info = resData.app_info||[];
                    this.total_info = resData.total_info||{};

                    this.dataLoading = true;
                    this.getDataList();
                },err=>{
                    this.totalLoading = false;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload();
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info);
                });
            },
            getDataList(){
                return new Promise((resolve, reject) => {
                    let reqData = {
                        task_id:this.id,
                        pn:this.queryData.pn,
                        rn:this.queryData.rn,
                    };
                    API.getBatchPreviewList(reqData).then(res1=>{
                        let resData = res1.data||{};
                        this.totalCnt = resData.totalCnt;
                        this.dataLoading = false;
                        this.tableData = [this.total_info].concat(resData.list||[])
                        resolve()
                    },err1=>{
                        this.dataLoading = false;
                        if (err1.code == '403') {
                            if(this.confirmTip) return;
                            this.confirmTip = this.$confirm(err1.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload();
                                this.confirmTip = null;
                            }).catch(() => {
                                this.confirmTip = null;
                            });
                            return
                        }
                        this.$message.error(err1.info);
                        reject()
                    })
                })

            },
            tableRowClassName({row, rowIndex}){
                if (rowIndex === 0) {
                    return 'gray-row gray-row-disabled';
                }
                return '';
            },
            submitTask(){
                this.submitLoading = true;
                API.saveBatchTask({
                    task_id:this.id,
                }).then(res=>{
                    this.submitLoading = false;
                    console.log('saveBatchTask',res);
                    this.$message.success(res.info||'创建成功');

                    let $routeParams = this.$route.params;
                    let $routeQuery = this.$route.query;
                    let pageType = $routeParams.pageType||$routeQuery.pageType||'';
                    if(pageType=='mi_batch_v2_task_list'&&($routeParams.search||$routeQuery.search)){
                        /* 通过跳转来的页面，不清理 */
                        // this.$emit("clearAlive");

                    }else{
                        this.$emit("clearAlive");
                    }

                    this.$emit("changePage", "listPage",'',{})
                },err=>{
                    this.submitLoading = false;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload();
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }


                    if(err.data.err_type == 'msg') {
                        this.$message.error(err.info);
                    }else{
                        const { vm } = submitErrorModal(
                            {
                                props: {
                                    id:this.id,
                                    info: err.info,
                                    type: err.data.err_type,
                                    list: err.data['err_data'] ? err.data['err_data'] : []
                                },
                                cbs:{
                                    onSubmit:(data)=>{
                                        this.getDataList().then(()=>{
                                            this.submitTask()
                                        })
                                        vm.close()
                                    },
                                }
                            }
                        )
                    }
                });
            },
            handleEditName(title, type, rows) {
                // rows 存在为单个修改 description_conf_length
                let res_detail_id = ''
                let res_maxLength = 0
                let text = ''
                if(rows) {
                    res_detail_id = [rows.detail_id]
                    res_maxLength = rows[`${type}_conf_length`]
                    text = rows[type] ? rows[type] : ''
                }else{
                    if(this.multipleSelection.length == 0) {
                        this.$message.error(`请先选择要修改的广告`)
                        return
                    }
                    res_detail_id = this.multipleSelection.map(item=>item.detail_id)
                    let cur_list = this.multipleSelection.filter(item=> item[type] && item[`${type}_conf_length`] != 0)
                    let get_res_maxLength = cur_list.map(item=>item[`${type}_conf_length`])
                    if(get_res_maxLength.length == 0) {
                        this.$message.error(`选择的广告此项无需填写`)
                        return;
                    }
                    res_maxLength = Math.max(...get_res_maxLength)

                    if(cur_list && cur_list.length == 1){
                        text = cur_list[0][type] ? cur_list[0][type] : ''
                    }
                }
                const { vm } = adsEditNameModal(
                    {
                        props: {
                            title: title,
                            maxlength: res_maxLength,
                            detail_id:res_detail_id,
                            text: text,
                            type: type
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                vm.close()
                                this.getTotalData()
                            },
                        }
                    }
                )
            },
            handleDoubleConfirmation() {
                const { vm } = doubleConfirmationModal(
                    {
                        props: {
                            id:this.id,
                            // type: type
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                vm.close()
                                this.getTotalData()
                            },
                        }
                    }
                )
            },
            // 禁止选中
            checkSelect(row, index) {
                return index !== 0 && (row.description || row.product_description || row.brand)
            },
            // 设置选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getFixWidth)
        }
    }
</script>

<style lang="scss" scoped>
.mi_previewBoxflex{
    cursor: pointer;
    display: flex;
    align-items: center;
    .edit{
        width: 30px;
        cursor: pointer;
    }

}
.ellipsis-row-2{
    width: 100%;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
    ::v-deep.el-table .gray-row{
        background-color: #f4f4f4;
    }
    .bg-wrap-color{
        background-color:#F1F4F9;
    }
    .bg-color{
        background-color:#FFF;
    }
    .mi_create_header_fixed{
        position: fixed;
        z-index: 2;
        top: 50px;
        border-bottom: solid 1px #eee;
    }
</style>
<style lang="scss">
.gray-row-disabled{
    .is-disabled{
        opacity: 0;
    }
}
</style>
